<!--

	Was macht diese Componente?
	Wofür ist die Compoente da?

	Welche $props gibt es?

	Beispiel Code:
		<DocForm></DocForm>

	2021-04-01	init

-->

<template>
	<div class="DocForm maxWidth maxWidth--page background background--white" :class="elmClasses" v-if="doc">
		<div class="DocForm__inner">

			<!--
			<pre>{{doc.get()}}</pre>
			<pre>{{doc.scheme.thesauri}}</pre>
			<pre>{{doc.getThesauri('landkreise')}}</pre>
			<pre>{{doc.getDatasets()}}</pre>
			-->

			<div class="DocForm__header background background--lightGrey">
				<div class="DocForm__headerTitle flex flex--spaceBetween vhSpace vhSpace--medium font font--sizeBig">
					<span>{{doc.title}}</span>
					<!--
					<a @click="closeDoc()">×</a>
					-->
				</div>
			</div>

			<div class="DocForm__body">
				<div class="DocForm__datasetRow flex hSpace hSpace--medium"
					 v-for="(dataset, datasetIndex) in doc.datasets"
					 :key="datasetIndex"
					 :class="{
						 'DocForm__datasetRow--isHidden'  : (app.showErrorsOnly && dataset.isValid) || !dataset.gui.isVisible,
						 'DocForm__datasetRow--isValid'   : dataset.isValid,
						 'DocForm__datasetRow--isInvalid' : !dataset.isValid,
					 }">
					 	<div class="DocForm__datasetRowLeft">
							<div class="DocForm__datasetLabel vSpace vSpace--default font font--sizeSmall font--bold" v-html="dataset.title"></div>
							<div class="DocForm__datasetFormElm">

								<template v-if="dataset.gui.element == 'input'">
									<BaseText
										:value="dataset.value"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseText>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

								<template v-if="dataset.gui.element == 'customZweckDesFotos'">
									<BaseCheckbox
										:value="'Dokumentation'"
										:label="'Dokumentation'"
										@input="setCustomZweckDesFotos('Dokumentation', $event)"
									></BaseCheckbox><br/>
									<BaseCheckbox
										:value="'Publikation'"
										:label="'Publikation'"
										@input="setCustomZweckDesFotos('Publikation', $event)"
									></BaseCheckbox><br/>
									<!--
									<pre name="customZweckDesFotos">{{customZweckDesFotos}}</pre>
									<pre name="dataset">{{dataset}}</pre>
									-->
								</template>

								<template v-if="dataset.gui.element == 'customDienstort'">
									<div>
										<BaseRadio
											v-model="customDienstort"
											:checked-value="'thesauri'"
											:label="'vorgegebene Werte'"
											:name="'myGroup'"
											@input="doc.setDatasetValue( dataset.key, '' )"
										></BaseRadio>
										<span class="DocForm__datasetFormElmSpacer"></span>
										<BaseRadio
											v-model="customDienstort"
											:checked-value="'freetext'"
											:label="'freie Eingabe'"
											:name="'myGroup'"
											@input="doc.setDatasetValue( dataset.key, '' )"
										></BaseRadio>
									</div>
									<!--
									<pre name="customDienstort">{{customDienstort}}</pre>
									-->

									<BaseSelect
										v-if="customDienstort === 'thesauri'"
										:label="'Bitte wählen ...'"
										:value="dataset.value"
										:options="doc.getThesauri( dataset.gui.thesaurus( doc.pairs ) )"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseSelect>
									<BaseText
										v-if="customDienstort === 'freetext'"
										:value="dataset.value"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseText>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

								<template v-if="dataset.gui.element == 'date'">
									<BaseDate
										:value="dataset.value"
										:format="'dd.mm.yyyy'"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseDate>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

								<template v-if="dataset.gui.element == 'select'">
									<BaseSelect
										:label="'Bitte wählen ...'"
										:value="dataset.value"
										:options="doc.getThesauri( dataset.gui.thesaurus( doc.pairs ) )"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseSelect>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

								<template v-if="dataset.gui.element == 'multiselect'">
									<BaseSelect
										:label="'Bitte wählen ...'"
										:value="_.toString( dataset.value ).split(', ')"
										:options="doc.getThesauri( dataset.gui.thesaurus( doc.pairs ) )"
										:multiple="true"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseSelect>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

								<template v-if="dataset.gui.element == 'textarea'">
									<BaseTextarea
										:value="dataset.value"
										@input="doc.setDatasetValue( dataset.key, $event )"
									></BaseTextarea>
									<pre name="dataset.value" v-if="debugMode">{{dataset.value}}</pre>
								</template>

							</div>
						</div>
						<div class="DocForm__datasetRowRight" :class="{'color--darkGrey' : dataset.isValid, 'color--darkGrey' : !dataset.isValid}">
							<div class="DocForm__datasetMsg font font--sizeSmall vSpace vSpace--default">
								<div class="DocForm__datasetMsgTitle" v-if="_.get(dataset, 'message.title')" v-html="_.get(dataset, 'message.title')"></div>
								<div class="DocForm__datasetMsgText"  v-if="_.get(dataset, 'message.text')"  v-html="_.get(dataset, 'message.text')"></div>
							</div>
						</div>
				</div>
				<pre name="app.doc.pairs" v-if="debugMode">{{app.doc.pairs}}</pre>
			</div>
		</div>
	</div>
</template>

<script>
	// @ is an alias to /src
	import { EventBus } from '@/event-bus.js'
	import BaseText from '@/components/MhForm/v1/BaseText.vue'
	import BaseDate from '@/components/MhForm/v1/BaseDate.vue'
	import BaseSelect from '@/components/MhForm/v1/BaseSelect.vue'
	import BaseTextarea from '@/components/MhForm/v1/BaseTextarea.vue'
	import BaseRadio from '@/components/MhForm/v1/BaseRadio.vue'
	import BaseCheckbox from '@/components/MhForm/v1/BaseCheckbox.vue'

	export default {
		name: 'DocForm',
		components: {
			BaseText,
			BaseDate,
			BaseSelect,
			BaseTextarea,
			BaseRadio,
			BaseCheckbox,
		},
		mixins: [],
		props: {},
		data() {
			return {
				customDienstort : 'thesauri',
				customZweckDesFotos : {
					'Dokumentation' : false,
					'Publikation' : false,
				},
			}
		},
		watch: {},
		computed: {
			app() {
				return this.$root.$children[0]
			},
			doc() {
				return this.app.doc
			},
			elmClasses(){
				let classes = []

				//classes.push('new_class')

				return classes
			},
			debugMode(){
				return this.app.isDevEnv
			},
		},
		methods: {
			setCustomZweckDesFotos( key, value ){
				this.customZweckDesFotos[key] = value

				let valueToSet = []
				this._.forEach( this.customZweckDesFotos, (value, key) =>{
					if( value ) valueToSet.push( key )
				})
				valueToSet = valueToSet.join(', ')

				/*
				console.group('setCustomZweckDesFotos()')
				console.log('key:', key)
				console.log('value:', value)
				console.log('valueToSet:', valueToSet)
				console.groupEnd()
				*/

				this.doc.setDatasetValue( 'zweck_des_fotos', valueToSet )
			},
		},
		created() {},
		mounted() {},
		destroyed () {},
	}
</script>

<style lang="less">
	@import (reference) "../less/vars.less";
	@import (reference) "../less/mixins.less";
	@import (reference) "../less/atoms.less";

	.DocForm {
		display: flex;
		flex-direction: row;
		flex-grow: 1;
		width: 100%;
		margin: 0 auto;
		overflow: hidden;

		border: 1px solid fade( black, 40 );
		box-shadow: 0 0 1em 0em fade( black, 10 );
		border-top-left-radius: 0.25em;
		border-top-right-radius: 0.25em;
	}
	.DocForm__inner {
		flex-grow: 1;
		max-width: 100%;
	}
	.DocForm__header {
		border-bottom: 1px solid @swatches[middleGrey];

		&Title {
			span {
				opacity: 0.75;
				text-overflow: ellipsis;
				overflow: hidden;
				max-width: calc( 100% - 1em );
			}
		}
		a {
			text-decoration: none;
		}
	}
	.DocForm__body {
		padding-bottom: 0 !important;
	}

	.DocForm__datasetRow {
		//& > * { outline: 1px solid fade(red, 25); }

		display: flex;
		border-top: 1px solid @swatches[middleGrey];
		border-bottom: 1px solid @swatches[middleGrey];
		padding-bottom: 1em;
		margin-top: -1px;

		&--isHidden {
			display: none;
		}
		&--isInvalid {
			background-color: @swatches[lightRed];
			//border-top: 1px solid @swatches[darkRed];
			//border-bottom: 1px solid @swatches[darkRed];
			//margin-top: -1px;
		}

		&Left {
			width: 60%;
			padding-right: 0.5em;
			flex-shrink: 0;
		}
		&Right {
			flex-grow: 1;
			padding-left: 0.5em;
		}

		&--isInvalid .DocForm__datasetLabel {
			color: @swatches[darkRed];
		}
	}
	.DocForm__datasetMsg {
		line-height: 1.3em;

		&Title {
			padding-bottom: 0.35em;
		}
		&Text {
			padding-top: 0.35em;
			//background-color: fade( green, 20 );

			//&::before { content : "Beispiel:"; }
		}
		p + p {
			padding-top: 0.35em;
		}
	}
	.DocForm__datasetFormElmSpacer { // spacer between horizontal radio elms
		width: 1em;
		height: 1em;
		display: inline-block;
	}

	@media @mediaQueries[xs] {}
	@media @mediaQueries[sm] {}
	@media @mediaQueries[md] {}
	@media @mediaQueries[dt] {}
	@media @mediaQueries[lg] {}
	@media @mediaQueries[xl] {}
</style>
